module.exports = __webpack_public_path__ + "static/img/200105.c28b6d27.png";